import React, { useState, useEffect } from 'react';
import { businessAPI } from '../../api/businesses';

const WorkingHours = () => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hours, setHours] = useState({
    monday: [{ start: '09:00', end: '22:00' }],
    tuesday: [{ start: '09:00', end: '22:00' }],
    wednesday: [{ start: '09:00', end: '22:00' }],
    thursday: [{ start: '09:00', end: '22:00' }],
    friday: [{ start: '09:00', end: '22:00' }],
    saturday: [{ start: '09:00', end: '22:00' }],
    sunday: []
  });

  const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  useEffect(() => {
    loadHours();
  }, []);

  const loadHours = async () => {
    try {
      setLoading(true);
      // First get the business ID of the current user
      const bizRes = await businessAPI.getMyBusiness();
      const bizId = bizRes.data.data.id;
      
      const response = await businessAPI.getWorkingHours(bizId);
      if (response.data.data) {
        setHours(response.data.data);
      }
    } catch (error) {
      console.error('Failed to load hours:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSlot = (day) => {
    setHours({
      ...hours,
      [day]: [...hours[day], { start: '09:00', end: '22:00' }]
    });
  };

  const handleRemoveSlot = (day, index) => {
    const newSlots = [...hours[day]];
    newSlots.splice(index, 1);
    setHours({ ...hours, [day]: newSlots });
  };

  const handleSlotChange = (day, index, field, value) => {
    const newSlots = [...hours[day]];
    newSlots[index][field] = value;
    setHours({ ...hours, [day]: newSlots });
  };

  const handleToggleDay = (day, isOpen) => {
    if (isOpen) {
      setHours({ ...hours, [day]: [{ start: '09:00', end: '22:00' }] });
    } else {
      setHours({ ...hours, [day]: [] });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const bizRes = await businessAPI.getMyBusiness();
      const bizId = bizRes.data.data.id;
      
      await businessAPI.setWorkingHours(bizId, hours);
      alert('Working hours saved successfully!');
    } catch (error) {
      console.error('Failed to save hours:', error);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center py-8">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold mb-6">Working Hours</h1>
        <p className="text-gray-600 mb-1">Set your business operating hours</p>
        <p className="text-gray-500 text-sm mb-6">For break time (example 1 PM–2 PM), add multiple slots (9 AM–1 PM and 2 PM–10 PM).</p>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          {days.map((day) => (
            <div key={day} className="border-b pb-4">
              <div className="flex items-center justify-between mb-3">
                <label className="text-lg font-semibold capitalize">{day}</label>
                <label className="flex items-center space-x-2">
                  <span className="text-sm text-gray-600">Closed</span>
                  <button
                    type="button"
                    onClick={() => handleToggleDay(day, hours[day].length === 0)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      hours[day].length > 0 ? 'bg-primary-600' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        hours[day].length > 0 ? 'translate-x-6' : 'translate-x-1'
                      }`}
                    />
                  </button>
                  <span className="text-sm text-gray-600">Open</span>
                </label>
              </div>
              
              {hours[day].length > 0 && (
                <div className="space-y-3">
                  {hours[day].map((slot, index) => (
                    <div key={index} className="flex items-center space-x-3">
                      <input
                        type="time"
                        value={slot.start}
                        onChange={(e) => handleSlotChange(day, index, 'start', e.target.value)}
                        className="input w-32"
                      />
                      <span>to</span>
                      <input
                        type="time"
                        value={slot.end}
                        onChange={(e) => handleSlotChange(day, index, 'end', e.target.value)}
                        className="input w-32"
                      />
                      <button
                        type="button"
                        onClick={() => handleRemoveSlot(day, index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        Remove
                      </button>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => handleAddSlot(day)}
                    className="text-sm text-primary-600 hover:text-primary-700"
                  >
                    + Add time slot
                  </button>
                </div>
              )}
            </div>
          ))}
          
          <button
            type="submit"
            disabled={saving}
            className="w-full btn-primary disabled:opacity-50"
          >
            {saving ? 'Saving...' : 'Save Working Hours'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default WorkingHours;
